import { render } from "./SupportArticleForm.vue?vue&type=template&id=905d9848&scoped=true"
import script from "./SupportArticleForm.vue?vue&type=script&lang=js"
export * from "./SupportArticleForm.vue?vue&type=script&lang=js"

import "./SupportArticleForm.vue?vue&type=style&index=0&id=905d9848&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905d9848"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QCheckbox,QTooltip,QSelect,QEditor,QVideo});
